import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-unify-marketing-details-form',
  templateUrl: './unify-marketing-details-form.component.html',
  styleUrls: ['./unify-marketing-details-form.component.css']
})
export class UnifyMarketingDetailsFormComponent implements OnInit {

  Pros_Id: any;
  prospectresponse;
  prospectdetail: any = {};
  presponse: any = {};
  statusList;
  data: any;
  formSubmitted: boolean;
  fileToUpload: File = null;
  mindate: any;
  count: any;
  Status: any;
  PR_Id: any;
  Proj: any = {};
  forwardlist;
  Forwardto: any;

  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private errorHandler: ErrorHandler) {
    this.formSubmitted = false;
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.Pros_Id = params['Pros_Id']
      this.PR_Id = params['PR_Id']

    });
    this.GetAllUserName(this.Pros_Id);

    if (this.Pros_Id != null)
      this.GetProspectForTheId(this.PR_Id);
    this.GetProspectResponse(this.Pros_Id);
  }

  GetAllUserName(Pros_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllUserName(Pros_Id)
      .subscribe(
        (data: any) => {
          this.Proj = data;
          this.forwardlist = data.ProspectForwardmodels;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetProspectForTheId(PR_Id: any) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetProspectForTheId(PR_Id)
      .subscribe(
        (data: any) => {
          this.prospectdetail = data;
          this.Forwardto = this.prospectdetail.PR_To_UserId;
          this.mindate = new Date();
          //this.presponse.PR_Appt_Datetime=this.mindate;
          //this.presponse.PR_Appt_Datetime.setDate( this.presponse.PR_Appt_Datetime.getDate() + 3 )
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetProspectResponse(Pros_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetProspectResponse(Pros_Id)
      .subscribe(
        (data: any) => {
          this.prospectresponse = data;
          for (let i = 0; i < this.prospectresponse.length; i++) {
            if (this.Status == null) {
              if (this.prospectresponse[i].Pros_Status == 3) {
                this.Status = "close";
              }
            }
          }
          for (let i = 0; i < this.prospectresponse.length; i++) {
            this.presponse.PR_Visited_Datetime = this.prospectresponse[i].PR_TS;
      }
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  onSubmit(form: NgForm, Pros_Id: any) {
    if (!form.invalid) {
      if (form.value.PR_To_UserId == this.Forwardto) {
        document.getElementById('loader-spinner').style.display = "none";
        swal('Warning!', 'Forwarding to Same User is not Allowed', 'warning');
      }
      else {
        form.value.PR_Upload_Doc = this.getFeasibilityPDFUrl();
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.CreateProspectResponse(form.value, Pros_Id,this.PR_Id);
        this.data.subscribe(
          (response) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('Success!', 'Updated Successfully.', 'success');
            this.router.navigate(['/home/marketing-alert']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
      }
    }
    else {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
      this.formSubmitted = true;
    }
  }

  imageUpload(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('PR_Upload_Doc');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('PR_Upload_Doc');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getFeasibilityPDFUrl() {
    debugger;
    let imagename = null;
    try {
      imagename = document.getElementById('PR_Upload_Doc');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/prospect/unify-marketing-details/unify-marketing-details-form/unify-marketing-details-form.component.ts